import { Component, EventEmitter, Inject, Output } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { RouteCMRController } from '@shared/src/controllers/route/cmr/routecmr.controller';
import { Route_eCMRHandlingAndTransportationDto } from '@shared/src/dtos/route/cmr/ecmrparts/Route_eCMRHandlingAndTransportationDto';

@Component({
  selector: 'updatehandlingandtransportationdialog-dialog',
  templateUrl: './updatehandlingandtransportationdialog.dialog.component.html'
})
export class UpdateHandlingAndTransportationDialogDialogComponent {

  @Output() public onResolve: EventEmitter<boolean> = new EventEmitter<boolean>();

  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
    private mdDialogRef: MatDialogRef<UpdateHandlingAndTransportationDialogDialogComponent>,
    private mdDialog: MatDialog,
    private ecmrController: RouteCMRController) { }

  onClose() {
    this.onResolve.next(false);
    this.mdDialog.closeAll();
  }

  onConfirm() {
    this.ecmrController.updateHandlingAndTransportation(this.data.routePartCMRId, Route_eCMRHandlingAndTransportationDto.build(this.data.handlingAndTransportation)).subscribe(e => {
      if (e) {
        this.onResolve.next(true);
        this.mdDialog.closeAll();
      }
    });
  }
}